import { faEdit, faShoppingCart } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { error } from "../../actions/alertAction";
import {
  addFinalCartItem,
  applyPromoCode,
  clearCartItems,
  getCartItems,
} from "../../actions/cartAction";
import {
  getUnfinalizedPrescription,
  getUnOrderedPrescription,
} from "../../actions/prescriptionAction";
import {
  getBillingShippingAddress,
  getCreditCards,
  getShippingPrice,
} from "../../actions/profileAction";
import {
  getPrescriptionFormSettings,
  getFreeShippingSettings,
  getPickupAddress,
} from "../../actions/settingsActions";
import BreadCrumb from "../../components/Breadcrumb";
import CartItem from "../../components/CartItem";
import CartProductItem from "../../components/CartProductItem.js";
import Loader from "../../components/Loader";
import { BOTH_CART_ITEM_RECEIVED } from "../../constants/types/cartType";
import {
  calculateCommisionAndPreparationValue,
  getPrepName,
  getUserDetail,
  groupByKey,
} from "../../utils/helper";
import {
  acumaticaGetCustomerPaymentMethods,
  getCustomerById,
} from "../../actions/acumaticaAction";
import OrderReview from "../OrderReview";
import AddressListPopup from "../Profile/AddressListPopup";
import CardListPopup from "../Profile/CardListPopup";
import Select from "react-select";
import {
  ADDRESS_LIST_RETERIEVED,
  CARD_LIST_RETRIEVED,
} from "../../constants/types/profileType.js";
const ShoppingCart = () => {
  const dispatch = useDispatch();

  const cardList = useSelector((state) => state.profile.cardList);
  const addressList = useSelector((state) => state.profile.addressList);
  const cartItems = useSelector((state) => state.cart.activeCartItem);
  const finalCartItems = useSelector((state) => state.cart.finalCartItems);
  const promoDetail = useSelector((state) => state.cart.promoDetail);
  const pickupAddress = useSelector((state) => state.settings.pickupAddress);
  const customerByIdInfo = useSelector(
    (state) => state.acumatica.customerByIdInfo.contacts
  );
  const isTaxExempt = false;
  const shippingPrices = useSelector((state) => state.profile.shippingPrices);
  const [methodType, setMethodType] = useState(2);
  const [selectedCard, setSelectedCard] = useState(null);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [selectedShippingAddress, setSelectedShippingAddress] = useState(null);
  const [showAddressModal, setShowAddressModal] = useState(false);
  const [showShippingAddressModal, setShowShippingAddressModal] =
    useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [showOrderSection, setShowOrderSection] = useState(false);
  const [cvvValue, setCvvValue] = useState("");
  const [promoCode, setPromoCode] = useState("");
  const [showShippingOption, setShowShippingOption] = useState(true);
  const role = useSelector((state) => state.role.role);
  const [productList, setProductList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [shippingPrice, setShippingPrice] = useState(0);
  const [shippingCarrier, setShippingCarrier] = useState(null);
  const handleCheckoutClick = () => {
    if (!selectedAddress) {
      dispatch(error("Please choose billing address"));
      return;
    }
    if (!selectedShippingAddress) {
      dispatch(error("Please choose shipping address"));
      return;
    }

    if (!selectedCard) {
      dispatch(error("Please choose payment method"));
      return;
    }

    if (methodType < 2) {
      if (cvvValue.length < 3 || isNaN(cvvValue) || cvvValue.length > 4) {
        dispatch(
          error(
            "Card Security Code must be numeric and 3-4 digits long in length"
          )
        );
        return;
      } else {
        if (methodType == 0 && shippingPrice <= 0) {
          dispatch(error("Please select a shipping service"));
          return;
        }
        if (productList.some((x) => parseInt(x.totalQuantity) < 1)) {
          dispatch(error("Please remove out of stock items from you cart."));
          return;
        } else if (
          productList.some((x) => parseInt(x.totalQuantity) < x.quantity)
        ) {
          dispatch(error("Please select correct quantity for items."));
        } else {
          setShowOrderSection(true);
        }
      }
    } else {
      dispatch(error("Please select a delivery method"));
      return;
    }
  };

  const applyPromo = () => {
    dispatch(applyPromoCode(promoCode));
  };

  useEffect(() => {
    setProductList(cartItems.filter((x) => x.itemType == 0));
  }, [cartItems]);

  useEffect(() => {
    dispatch(
      getCartItems(role.val, () => {
        setLoading(false);
      })
    );
    dispatch(getFreeShippingSettings());
    dispatch(getPickupAddress());
    return () => {
      dispatch({
        type: ADDRESS_LIST_RETERIEVED,
        payload: [],
      });
      dispatch({
        type: BOTH_CART_ITEM_RECEIVED,
        payload: null,
      });
      dispatch({
        type: CARD_LIST_RETRIEVED,
        payload: [],
      });
    };
  }, []);

  useEffect(() => {
    if (selectedShippingAddress?.address_id) {
      dispatch(getShippingPrice(selectedShippingAddress.address_id, role.val));
    }
  }, [selectedShippingAddress]);

  useEffect(() => {
    if (shippingCarrier) {
      if (shippingPrices) {
        let newItem = shippingPrices.find(
          (x) =>
            x.carrier == shippingCarrier.value.carrier &&
            x.service == shippingCarrier.value.service
        );
        let item = {
          value: newItem,
          label: `${newItem.description} ($${
            newItem.rate
          }), Estimated Delivery: ${newItem.est_days} - ${
            newItem.est_days + 1
          } days `,
        };

        setShippingPrice(parseFloat(newItem.rate));
        setShippingCarrier(item);
      } else {
        setShippingPrice(0);
        setShippingCarrier(null);
      }
    }
  }, [shippingPrices]);

  const getPreparationValue = (
    preparationMethods,
    id,
    totalDosage = 0,
    totalPacket = 0,
    maximumGramForCreation
  ) => {
    let prepValue = 0;

    let prepMethod = preparationMethods?.find((x) => x.id == id);
    if (!prepMethod?.isRaw) {
      const weight = totalDosage * totalPacket;
      const nearestLowerMultiple =
        Math.floor(weight / parseFloat(prepMethod.multiple)) *
        parseFloat(prepMethod.multiple);
      const excess = weight - nearestLowerMultiple;
      let adjustedWeight;
      if (excess <= parseFloat(maximumGramForCreation)) {
        adjustedWeight = weight - excess;
      } else {
        adjustedWeight = weight;
      }
      prepValue =
        Math.ceil(adjustedWeight / parseFloat(prepMethod.perUnitQuantity)) *
        parseFloat(prepMethod.preparationValue);
    } else {
      prepValue = parseFloat(prepMethod.preparationValue) * totalPacket;
    }
    return prepValue;
  };

  useEffect(() => {
    if (!loading) {
      if (cartItems.length > 0) {
        dispatch(
          getPrescriptionFormSettings(
            (preparationMethods, maximumGramForCreation) => {
              cartItems.forEach((element2) => {
                if (element2.itemType == 1) {
                  if (role && role.val === 3 && element2.roleId == 3) {
                    dispatch(
                      getUnOrderedPrescription(
                        element2.prescriptionId,
                        (prescription) => {
                          if (prescription) {
                            let isGranular = prescription.Dosage_Type;
                            let prepPrice = 0;
                            let total_size_edit = prescription.Herbs.map((x) =>
                              parseFloat(x.dosage)
                            ).reduce((a, b) => a + b, 0);
                            prepPrice = getPreparationValue(
                              preparationMethods,
                              prescription.PRSC_Prep_Method,
                              total_size_edit,
                              prescription.PRSC_Serving_Total,
                              maximumGramForCreation
                            );
                            let item = {
                              description: `Prescription #${element2.prescriptionId} from ${prescription.Practitioner_Name}`,
                              prescriptionId: element2.prescriptionId,
                              prep_name: prescription.Prep_Method_Name,
                              formula: prescription.FORM_Custom,
                              total: (
                                prescription.Total_Price / 100 +
                                prepPrice
                              ).toFixed(2),
                              taxablePrice:
                                prescription.Total_Price / 100 + prepPrice,
                              weight: total_size_edit,
                            };
                            dispatch(addFinalCartItem(item));

                            setIsLoading(false);
                          }
                        }
                      )
                    );
                  } else {
                    dispatch(
                      getUnfinalizedPrescription(
                        element2.prescriptionId,
                        (prescription) => {
                          if (prescription) {
                            var singleHerbTotal = {
                              totalDosage: 0,
                              totalPrice: 0,
                            };
                            var overall;
                            var singleHerbList = [];
                            var formulaSection = [];
                            prescription[1]?.forEach((element) => {
                              if (element.form_id == 0) {
                                const item = {
                                  dosage: parseFloat(element.dosage),
                                  dosageInFloat: parseFloat(element.dosage),
                                  name: element.herb_display,
                                  id: element.herb_id,
                                  price:
                                    Math.ceil(
                                      ((element.dosage *
                                        (!prescription[0].Dosage_Type
                                          ? element.price_raw ?? 0
                                          : element.price_granular ?? 0)) /
                                        10000) *
                                        100
                                    ) / 100,
                                  percentage: 0,
                                  rawPrice: element.price_raw ?? 0,
                                  granularPrice: element.price_granular ?? 0,
                                };
                                singleHerbList.push(item);
                                const index = singleHerbList.findIndex(
                                  (x) => x.id === element.herb_id
                                );

                                let newList = JSON.parse(
                                  JSON.stringify(singleHerbList)
                                );

                                let newDosage =
                                  prescription[0]?.Dosage_Type === 0
                                    ? element.dosage /
                                      prescription[0]?.Serving_Total
                                    : element.dosage /
                                      prescription[0]?.Serving_Total;
                                newList[index].dosage = parseFloat(newDosage);
                                newList[index].dosageInFloat =
                                  parseFloat(newDosage);
                                newList[index].price =
                                  Math.ceil(
                                    ((newDosage *
                                      (!prescription[0].Dosage_Type
                                        ? newList[index].rawPrice
                                        : newList[index].granularPrice)) /
                                      10000) *
                                      100
                                  ) / 100;
                                let herbTotal = {
                                  totalPrice: parseFloat(
                                    newList
                                      .map((x) => x.price)
                                      .reduce((sum, val) => sum + val, 0)
                                      .toFixed(2)
                                  ),
                                  totalDosage: parseFloat(
                                    newList
                                      .map((x) => x.dosage)
                                      .reduce((sum, val) => sum + val, 0)
                                  ),
                                };
                                newList.forEach((x) => {
                                  x.percentage =
                                    x.dosageInFloat / herbTotal.totalDosage;
                                });
                                singleHerbList = newList;
                                singleHerbTotal = herbTotal;
                              }
                            });
                            let newFormulaSection = JSON.parse(
                              JSON.stringify(formulaSection)
                            );
                            let formulas = Object.entries(
                              groupByKey(prescription[1], "form_id")
                            );

                            formulas.forEach((formula) => {
                              if (formula[0] !== "0") {
                                formula[1].forEach(
                                  (x) =>
                                    (x.dosage =
                                      x.dosage / prescription[0]?.Serving_Total)
                                );

                                let herbList = [];
                                formula[1].forEach((x) => {
                                  const item = {
                                    dosage: parseFloat(
                                      x?.FORM_Dosage || x?.dosage
                                    ),
                                    dosageInFloat: parseFloat(
                                      x?.FORM_Dosage || x?.dosage
                                    ),
                                    name: x?.HERB_Display || x?.herb_display,
                                    id: x?.HERB_ID || x?.herb_id,
                                    price:
                                      Math.ceil(
                                        ((parseFloat(
                                          x?.FORM_Dosage || x?.dosage
                                        ) *
                                          (!prescription[0].Dosage_Type
                                            ? (x?.Price_Raw || x.price_raw) ?? 0
                                            : (x?.Price_Granular ||
                                                x?.price_granular) ??
                                              0)) /
                                          10000) *
                                          100
                                      ) / 100,
                                    rawPrice:
                                      (x?.Price_Raw || x.price_raw) ?? 0,
                                    granularPrice:
                                      (x?.Price_Granular || x.price_granular) ??
                                      0,
                                    isAdditional: false,
                                    isModification: false || x?.mod_id > 0,
                                  };
                                  herbList.push(item);
                                });

                                let formulaItem = {
                                  formulaHerbs: herbList,
                                  formulaName: formula[1][0].form_display,
                                  formulaId: formula[1][0].form_id,
                                  formulaDosage: parseFloat(
                                    herbList
                                      .map((x) => x.dosage)
                                      .reduce((sum, val) => sum + val, 0)
                                  ),
                                  formulaPrice: parseFloat(
                                    herbList
                                      .map((x) => x.price)
                                      .reduce((sum, val) => sum + val, 0)
                                      .toFixed(2)
                                  ),
                                };

                                newFormulaSection.push(formulaItem);
                              }
                            });

                            formulaSection = newFormulaSection;
                            let newOverall = {
                              totalPrice: parseFloat(
                                (
                                  newFormulaSection
                                    .map((x) => x.formulaPrice)
                                    .reduce((sum, val) => sum + val, 0) +
                                  singleHerbTotal.totalPrice
                                ).toFixed(2)
                              ),
                              totalDosage: parseFloat(
                                newFormulaSection
                                  .map((x) => x.formulaDosage)
                                  .reduce((sum, val) => sum + val, 0) +
                                  singleHerbTotal.totalDosage
                              ),
                            };

                            overall = newOverall;

                            let isGranular = prescription[0].Dosage_Type;

                            let item = {
                              description: `Prescription #${element2.prescriptionId} for ${prescription[0].Patient_Name}`,
                              prescriptionId: element2.prescriptionId,
                              prep_name: prescription[0].Prep_Method_Name,
                              formula: prescription[0].FORM_Custom,
                              isWhiteLabel:
                                prescription[0].Patient_ID ==
                                getUserDetail().id,
                              total: calculateCommisionAndPreparationValue(
                                overall.totalDosage,
                                overall.totalPrice,
                                prescription[0].Serving_Total,
                                prescription[0].Markup,
                                !isGranular,
                                prescription[0].Prep_Method,
                                preparationMethods,
                                maximumGramForCreation
                              ).toFixed(2),
                              weight: isGranular
                                ? overall.totalDosage *
                                  prescription[0].Serving_Total
                                : overall.totalDosage *
                                  prescription[0].Serving_Total,
                              taxablePrice:
                                calculateCommisionAndPreparationValue(
                                  overall.totalDosage,
                                  overall.totalPrice,
                                  prescription[0].Serving_Total,
                                  prescription[0].Markup,
                                  !isGranular,
                                  prescription[0].Prep_Method,
                                  preparationMethods,
                                  maximumGramForCreation
                                ),
                            };
                            dispatch(addFinalCartItem(item));
                            setIsLoading(false);
                          }
                        }
                      )
                    );
                  }
                } else {
                  setIsLoading(false);
                }
              });
            }
          )
        );
      } else {
        setIsLoading(false);
      }
    }
    return () => {
      dispatch(clearCartItems());
    };
  }, [cartItems, loading]);

  useEffect(() => {
    dispatch(getCreditCards());
    dispatch(getBillingShippingAddress());
  }, [dispatch]);

  useEffect(() => {
    if (finalCartItems.some((x) => x.prep_name === "Decoction")) {
      setShowShippingOption(false);
      setMethodType(1);
    } else {
      setShowShippingOption(true);
    }
  }, [finalCartItems]);

  useEffect(() => {
    if (cardList.length > 0) {
      if (selectedCard == null) {
        setSelectedCard(cardList[0]);
      }
    }
  }, [cardList]);

  useEffect(() => {
    if (addressList.length > 0) {
      if (selectedShippingAddress == null) {
        setSelectedShippingAddress(addressList[0]);
      }
      if (selectedAddress == null) {
        setSelectedAddress(addressList[0]);
      }
    }
  }, [addressList]);

  const getIsTaxExempt = () => {
    let isTaxable = false;
    isTaxable =
      (methodType == 0 &&
        !isTaxExempt &&
        selectedShippingAddress.state == "CA") ||
      (methodType == 1 && !isTaxExempt);
    return isTaxable;
  };

  useEffect(() => {
    setCvvValue("");
  }, [selectedCard]);

  return (
    <div id="cart-page">
      {isLoading && <Loader />}
      {showAddressModal && (
        <AddressListPopup
          activeAddress={selectedAddress}
          setActiveAddress={setSelectedAddress}
          anotherActiveAddress={selectedShippingAddress}
          setAnotherActiveAddress={setSelectedShippingAddress}
          closePopup={() => setShowAddressModal(false)}
        />
      )}
      {showPaymentModal && (
        <CardListPopup
          setActiveCard={setSelectedCard}
          activeCard={selectedCard}
          closePopup={() => setShowPaymentModal(false)}
        />
      )}
      {showShippingAddressModal && (
        <AddressListPopup
          activeAddress={selectedShippingAddress}
          setActiveAddress={setSelectedShippingAddress}
          anotherActiveAddress={selectedAddress}
          setAnotherActiveAddress={setSelectedAddress}
          closePopup={() => setShowShippingAddressModal(false)}
        />
      )}
      <BreadCrumb
        pageName={showOrderSection ? "Order Review" : "Shopping Cart"}
      />
      <div className="row">
        <div className="col-sm-12">
          <h3 className="page-title">
            {showOrderSection ? "Order Review" : "Shopping Cart"}
          </h3>
          {!showOrderSection && (
            <p className="page-desc">
              Please review the item(s) below before completing your
              prescription purchase.
            </p>
          )}
        </div>
      </div>
      {showOrderSection ? (
        <OrderReview
          billing={selectedAddress}
          shipping={selectedShippingAddress}
          payment={selectedCard}
          cartItems={finalCartItems}
          productList={productList}
          isShipping={methodType === 0}
          backAction={setShowOrderSection}
          cvvValue={cvvValue}
          promoCode={promoCode}
          shippingPrice={shippingPrice}
          shippingCarrier={shippingCarrier}
          isTaxable={getIsTaxExempt()}
        />
      ) : (
        <>
          <div className="row mt-2">
            <div className="col-md-6">
              <div className="row">
                <div className="col-md-12">
                  <h5 className="profile-title">Delivery Method</h5>
                  <hr />
                  <div className="d-flex">
                    <div className="radio-item">
                      <label
                        className="container"
                        onChange={() => setMethodType(1)}
                      >
                        Pickup: free
                        <input
                          type="radio"
                          checked={methodType === 1}
                          name="delivery"
                        />
                        <span className="checkmark"></span>
                      </label>
                    </div>
                    {!showShippingOption ? (
                      <>
                        <OverlayTrigger
                          placement="right"
                          delay={{ show: 200, hide: 100 }}
                          overlay={
                            <Tooltip id="button-tooltip-2">
                              Shipping is not available for decocted
                              prescriptions.
                            </Tooltip>
                          }
                        >
                          <div className="radio-item">
                            <label
                              style={{ opacity: "0.6" }}
                              className="container"
                              onChange={() => setMethodType(0)}
                            >
                              Ship:
                              <input
                                disabled={!showShippingOption}
                                type="radio"
                                name="delivery"
                                checked={methodType === 0}
                              />
                              <span className="checkmark"></span>
                            </label>
                          </div>
                        </OverlayTrigger>
                      </>
                    ) : (
                      <>
                        <div className="radio-item">
                          <label
                            disabled
                            className="container"
                            onChange={() => setMethodType(0)}
                          >
                            Ship: ${shippingPrice?.toFixed(2)}
                            <input
                              type="radio"
                              name="delivery"
                              checked={methodType === 0}
                            />
                            <span className="checkmark"></span>
                          </label>
                        </div>
                      </>
                    )}
                  </div>
                  {methodType === 1 && (
                    <p className="selectedItem">
                      MHP Pharmacy {pickupAddress.street}, {pickupAddress.city},{" "}
                      {pickupAddress.state} {pickupAddress.zip}
                    </p>
                  )}
                  {methodType === 0 && (
                    <>
                      <div className="carriers">
                        <p>Kindly choose from the services provided below.</p>
                        <div className="dropdown-wrapper">
                          <div className="service-dropdown">
                            <p className="mb-1">Shipping services: </p>
                            <Select
                              onChange={(e) => {
                                setShippingPrice(parseFloat(e.value.rate));
                                setShippingCarrier(e);
                              }}
                              // selectedValue={shippingCarrier}
                              placeholder="Please Select a Service"
                              value={shippingCarrier}
                              options={shippingPrices?.map((x) => ({
                                value: x,
                                label: `${x.description} ($${
                                  x.rate
                                }), Estimated Delivery: ${x.est_days} - ${
                                  x.est_days + 1
                                } days `,
                              }))}
                              styles={{
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 9999,
                                }),
                              }}
                              menuPortalTarget={document.body}
                              menuPlacement={"bottom"}
                              menuShouldScrollIntoView={false}
                              // formatOptionLabel={optionRenderer}
                            ></Select>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-md-12">
                  <h5 className="profile-title">Shipping Address</h5>
                  <hr />
                  {selectedShippingAddress && (
                    <p className="selectedItem">
                      {selectedShippingAddress?.address_nickname
                        ? `${selectedShippingAddress?.address_nickname} - `
                        : ""}
                      {selectedShippingAddress?.address_1}
                      {", "}
                      {selectedShippingAddress?.address_2 &&
                        `Apt ${selectedShippingAddress?.address_2},`}{" "}
                      {selectedShippingAddress?.city},{" "}
                      {selectedShippingAddress?.state}{" "}
                      {selectedShippingAddress?.zip}
                    </p>
                  )}
                  <p
                    className="small-btn"
                    onClick={() => setShowShippingAddressModal(true)}
                  >
                    Choose Other Address
                  </p>
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-md-12">
                  <h5 className="profile-title">Billing Address</h5>
                  <hr />
                  {selectedAddress && (
                    <p className="selectedItem">
                      {selectedAddress?.address_nickname
                        ? `${selectedAddress?.address_nickname} - `
                        : ""}
                      {selectedAddress?.address_1}
                      {", "}
                      {selectedAddress?.address_2 &&
                        `Apt ${selectedAddress?.address_2},`}{" "}
                      {selectedAddress?.city}, {selectedAddress?.state}{" "}
                      {selectedAddress?.zip}
                    </p>
                  )}
                  <p
                    className="small-btn"
                    onClick={() => setShowAddressModal(true)}
                  >
                    Choose Other Address
                  </p>
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-md-12">
                  <h5 className="profile-title">Payment Details</h5>
                  <hr />
                  {selectedCard && (
                    <>
                      <p className="selectedItem">{selectedCard.name}</p>
                      <input
                        className="cvv"
                        type="number"
                        placeholder="Card Security Code*"
                        value={cvvValue}
                        onChange={(e) => {
                          if (e.currentTarget.value.length <= 4) {
                            setCvvValue(e.currentTarget.value);
                          }
                        }}
                      />
                      <div className="row col-md-12">
                        <OverlayTrigger
                          placement="right"
                          delay={{ show: 200, hide: 100 }}
                          overlay={
                            <Tooltip id="button-tooltip-2">
                              The 'Card Security Code' on your credit or debit
                              card is a 3 digit number on VISA®, MasterCard®,
                              and Discover® branded credit and debit cards
                              located on the back of the card. On your American
                              Express® branded credit or debit card it is a 4
                              digit numeric code located on the front.
                            </Tooltip>
                          }
                        >
                          <p className="tip-text">What is it?</p>
                        </OverlayTrigger>
                      </div>
                    </>
                  )}
                  <div className="row col-md-12 ">
                    <p
                      className="small-btn"
                      onClick={() => setShowPaymentModal(true)}
                    >
                      Choose Other Payment
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <h5 className="profile-title">Your Cart</h5>
              <hr />
              {cartItems.length > 0 ? (
                <>
                  {finalCartItems.map((x) => {
                    return (
                      <CartItem
                        item={x}
                        key={x.prescriptionId}
                        ship_id={selectedShippingAddress?.address_id}
                      />
                    );
                  })}

                  {productList.map((x) => {
                    return (
                      <CartProductItem
                        item={x}
                        key={x.productId}
                        ship_id={selectedShippingAddress?.address_id}
                      />
                    );
                  })}
                </>
              ) : (
                <p className="page-desc">There are no items in your cart </p>
              )}
              {cartItems.length > 0 && (
                <>
                  {promoDetail && (
                    <div>
                      Promo code applied:
                      <p className="page-desc">{promoDetail.display}</p>
                    </div>
                  )}
                  <div className="promo">
                    <p className="page-desc">Promo Code:</p>
                    <input
                      type="text"
                      value={promoCode}
                      onChange={(e) => setPromoCode(e.target.value)}
                    />
                    <button
                      className="btn btn-orange promo-btn"
                      disabled={promoCode?.length < 1}
                      onClick={applyPromo}
                    >
                      {promoDetail ? "Change code" : "Apply"}
                    </button>
                  </div>

                  <div className="checkout-btn" onClick={handleCheckoutClick}>
                    <FontAwesomeIcon icon={faShoppingCart} />
                    <p>Proceed to checkout</p>
                  </div>
                </>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ShoppingCart;
